<template>
  <div class="invoice-item-container">
    <div class="invoice-item" :class="{ active: isActive }">
      <div class="invoice-item__top">
        <div class="left flex-09">
          <div class="section section-0">
            <img
              v-if="dataItem && dataItem.imageUrl"
              alt="product image"
              :src="dataItem.imageUrl"
            />
            <img
              v-else-if="dataItem && dataItem.application.imageUrl"
              alt="product image"
              :src="dataItem.application.imageUrl"
            />
            <base-icon v-else name="no-image" />
          </div>
          <div class="section section-main">
            <div class="section section-1">
              <h5>{{ dataItem.title }}</h5>
              <span>{{ dataItem.subtitle }}</span>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="col">
            <h6 class="bold">Bitiş Tarihi</h6>
            <span v-if="dataItem.endDate">
              {{ getTime(dataItem.endDate, "DD/MM/YYYY") }}
            </span>
            <span v-else>-</span>
          </div>

          <div class="col" v-if="esube == 'no'">
            <h6 class="bold">Ödeme Durumu</h6>
            <span v-if="dataItem.paymentStatus == '0'"
              >Limit altında müşteri, üstünde temsilci(Varsayılan)</span
            >
            <span v-if="dataItem.paymentStatus == '1'">Müşteri</span>
            <span v-if="dataItem.paymentStatus == '2'">Temsilci</span>
          </div>
          <div class="col" v-else>
            <h6 class="bold">Ödeme Durumu</h6>

            <span
              v-if="
                dataItem.paymentStatus == '0' &&
                isCompleted &&
                invoiceList.data.length
              "
              >Ücretsiz</span
            >
            <span
              v-if="
                dataItem.paymentStatus == '0' &&
                !isCompleted &&
                invoiceList.data.length
              "
              >Tahsil Edildi</span
            >
            <span v-if="dataItem.paymentStatus == '1' && isPastDate"
              >Tahsil Edildi</span
            >
            <span
              v-if="
                dataItem.paymentStatus == '1' && (isFutureDate || isFilterEmpty)
              "
              >Tahsil Edilecektir</span
            >
            <span v-if="dataItem.paymentStatus == '2'">Ücretsiz</span>
          </div>

          <div class="col">
            <h6 class="bold">Toplam Tutar</h6>
            <span v-if="dataItem.updatedAt">
              {{ totalPriceCalc.toString() }}
            </span>
          </div>
        </div>
        <div class="right for-button" v-if="dataItem.packageStatus">
          <div
            class="col"
            v-if="
              dataItem.packageStatus.id !== 6 &&
              dataItem.packageStatus.id !== 8 &&
              !isTradingView
            "
          >
            <div v-if="dataItem.packageStatus && getUserInfo.memberType == 1">
              <div
                v-if="dataItem.packageStatus.id == 2"
                class="invoice-item__bottom buttons"
              >
                <base-button
                  class="set-buttons"
                  :class="!isButtonsDisabled ? '' : 'disabled'"
                  @click="showModal(String(dataItem.id))"
                  >İşlemler</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="invoice-item__bottom" v-if="dataItem.package">
        <div class="left package-container">
          <div class="item">
            <strong>Paketler:</strong>
            <span
              class="items"
              v-for="(item, index) in mergedPackagesNames"
              :key="item"
              :class="{ hide: isActivatedAccordion }"
            >
              {{ item }}
              <span
                v-if="index != mergedPackagesNames.length - 1"
                class="seperator"
              ></span>
            </span>
          </div>
        </div>
        <div class="right" @click="accordionToggle">
          <base-icon
            :class="['toggle', { active: isActivatedAccordion }]"
            name="arrow-green"
          />
        </div>
        <div class="invoice-item__bottom__packages">
          <div
            :class="['accordion-wrapper', isActivatedAccordion ? 'active' : '']"
          >
            <div
              :class="[
                'accordion-wrapper__row caption',
                isActivatedAccordion ? 'active' : '',
              ]"
            >
              <div class="accordion-wrapper__row__cell caption">Paket Adı:</div>
              <div class="accordion-wrapper__row__cell caption">
                Başlangıç Tarihi:
              </div>
              <div class="accordion-wrapper__row__cell caption">
                Bitiş <br class="xs" />Tarihi:
              </div>
              <div class="accordion-wrapper__row__cell caption">
                <span class="my__price-text desktop">{{ pricesText }}</span>
              </div>
            </div>
            <div class="accordion-content active">
              <div
                class="accordion-wrapper__row"
                v-for="(item, index) in mergedForTableData"
                :key="item[index]"
              >
                <div class="accordion-wrapper__row__cell">
                  <span v-if="typeof item == 'object'">
                    <span v-if="item.name">{{ item.name }}</span>
                  </span>
                  <span v-else>{{ item }}</span>
                </div>
                <div class="accordion-wrapper__row__cell" v-if="item.startDate">
                  {{ getTime(item.startDate, "DD/MM/YYYY") }}
                </div>
                <div class="accordion-wrapper__row__cell" v-else>-</div>
                <div class="accordion-wrapper__row__cell" v-if="item.endDate">
                  {{ getTime(item.endDate, "DD/MM/YYYY") }}
                </div>
                <div class="accordion-wrapper__row__cell" v-else>-</div>
                <div class="accordion-wrapper__row__cell" v-if="item.price">
                  <span class="my__price-text hidden-sm">{{ pricesText }}:</span
                  >&nbsp;{{ item.price }}
                  <span v-if="item.info == '₺'">&nbsp;TL</span>
                  <span v-else-if="item.info == '€'">&nbsp;EUR</span>
                  <span v-else-if="item.info == '$'">&nbsp;USD</span>
                </div>
                <div class="accordion-wrapper__row__cell" v-else>0 TL</div>
              </div>

              <div class="accordion-wrapper__row screenPrice">
                <div class="accordion-wrapper__row__cell">
                  <span class="screen-price">Ekran Ücreti: </span>
                </div>
                <div class="accordion-wrapper__row__cell"></div>
                <div class="accordion-wrapper__row__cell"></div>
                <div class="accordion-wrapper__row__cell">
                  {{ screenPrice }}
                  TL
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      height="auto"
      class="cancel-modal"
      :adaptive="true"
      :name="String(dataItem.id)"
    >
      <div class="modal-heading">
        <div class="modal-title">
          <h5>Seçilen lisansı aşağıdaki şekilde yönlendirebilirsiniz.</h5>
        </div>
        <a @click="closeModal(String(dataItem.id))">
          <base-icon class="close" name="close-circle" />
        </a>
      </div>
      <div class="modal-body">
        <div class="modal-body__top">
          <div class="modal-body__info">
            <h3 class="title" v-if="dataItem.productName != null">
              {{ dataItem.productName }}
            </h3>
            <p class="modal-body__info-platform">
              <span
                v-if="
                  dataItem.application != null &&
                  (dataItem.application.applicationId == 3 ||
                    dataItem.application.applicationId == 2)
                "
                >{{ dataItem.application.shortContent }}</span
              >
              <span
                v-else-if="
                  dataItem.research.length && dataItem.application == null
                "
                >{{ dataItem.research[0].name }}</span
              >
              <span
                v-else-if="
                  dataItem.algorithm.length &&
                  (dataItem.application.applicationId == 4 ||
                    dataItem.application.applicationId == 7)
                "
                >{{ dataItem.algorithm[0].name }}</span
              >
              <span v-else-if="dataItem.platform?.name">
                {{ dataItem.platform.name }}
              </span>
              <span v-else>-</span>
            </p>
            <p class="modal-body__info_price">
              <template
                v-if="
                  totalPriceCalc != '0₺' &&
                  totalPriceCalc != '0€' &&
                  totalPriceCalc != '0$'
                "
                >{{ totalPriceCalc }}</template
              >
              <template v-else>Ücretsiz</template>
            </p>
          </div>
        </div>
        <info-area
          :infoText="'Uyarı: Yapılan işlemler geri alınamaz.'"
        ></info-area>
      </div>
      <div class="modal-bottom">
        <base-button
          class="set-buttons back"
          :class="!isButtonsDisabled ? '' : 'disabled'"
          @click="setRowForPrev(dataItem.id)"
          >Geri Al</base-button
        >
        <base-button
          class="set-buttons"
          :class="!isButtonsDisabled ? '' : 'disabled'"
          @click="setRowForNext(dataItem.id)"
          >İleri Al</base-button
        >
      </div>
    </modal>
  </div>
</template>

<script>
import { BaseIcon, BaseButton, InfoArea } from "@/components";
import mixins from "../../mixins";
import { CurrencySymbol } from "../../constants";
import { mapActions, mapGetters } from "vuex";
import { getItem } from "../../utils/tokenTools";
export default {
  name: "DataInvoiceItem",
  props: {
    dataItem: Object,
  },
  mixins: [mixins],
  components: {
    BaseIcon,
    BaseButton,
    InfoArea,
  },

  data() {
    return {
      isActive: false,
      isButtonsDisabled: false,
      purchaseTypes: {
        prev: 1,
        next: 2,
      },
      esube: getItem("esube"),
      pricesText: window.innerWidth < 768 ? "Tutar" : "Fiyat",
      isActivatedAccordion: false,
      thisMonth: new Date().getMonth() + 1,
      thisYear: new Date().getFullYear(),
    };
  },

  methods: {
    ...mapActions(["movePurchaseDates"]),
    getTime(dateTime, formatType) {
      if (dateTime) {
        let stringDateTime = String(dateTime);
        let generateMomentDate = this.$moment(new Date(stringDateTime)).format(
          formatType
        );
        return generateMomentDate;
      } else {
        return "-";
      }
    },
    setRowForPrev(purchaseId) {
      this.setRowForPurchase(purchaseId, this.purchaseTypes.prev);
    },
    setRowForNext(purchaseId) {
      this.setRowForPurchase(purchaseId, this.purchaseTypes.next);
    },
    setRowForPurchase(purchaseId, purchaseMoveType) {
      this.isButtonsDisabled = true;
      this.movePurchaseDates({
        purchaseId: purchaseId,
        purchaseMoveType: purchaseMoveType,
      }).then((response) => {
        if (response.error) {
          this.$toast.error(response.message);
        } else {
          this.$toast.success("Durum güncellendi.");
          this.closeModal(String(purchaseId));
        }
        this.isButtonsDisabled = false;
      });
    },
    showModal(modalId) {
      this.$modal.show(modalId);
    },
    closeModal(modalId) {
      this.$modal.hide(modalId);
    },
    accordionToggle() {
      this.isActivatedAccordion = !this.isActivatedAccordion;
    },
  },
  computed: {
    ...mapGetters([
      "getUserInfo",
      "fundAndCommissionRates",
      "getInvoiceFilter",
    ]),
    currencySymbol() {
      return CurrencySymbol;
    },
    isTradingView() {
      const title = (this.dataItem?.productName || this.dataItem?.title || "")
        .toString()
        .trim()
        .toLowerCase();

      const algoName = (this.dataItem?.algorithm?.[0]?.name || "")
        .toString()
        .trim()
        .toLowerCase();

      return title === "trading view" || algoName === "trading view";
    },
    isPastDate() {
      const filter = this.getInvoiceFilter.filter;
      const year = Object.keys(filter).includes("Year")
        ? filter.Year
        : this.thisYear;
      const month = Object.keys(filter).includes("Month")
        ? filter.Month
        : this.thisMonth;

      return (
        this.dataItem.paymentStatus == "1" &&
        (year < this.thisYear ||
          (year === this.thisYear && month < Number(this.thisMonth)))
      );
    },
    isFutureDate() {
      const filter = this.getInvoiceFilter.filter;
      const year = Object.keys(filter).includes("Year")
        ? filter.Year
        : this.thisYear;
      const month = Object.keys(filter).includes("Month")
        ? filter.Month
        : this.thisMonth;

      return (
        this.dataItem.paymentStatus == "1" &&
        (year > this.thisYear ||
          (year === this.thisYear && month >= Number(this.thisMonth)) ||
          Object.keys(filter).length === 0)
      );
    },
    isFilterEmpty() {
      return Object.keys(this.getInvoiceFilter.filter || {}).length === 0;
    },
    totalPriceTl() {
      return this.dataItem?.price?.prices?.filter(
        (e) => e.info === this.currencySymbol.tl
      )[0].totalPrice;
    },
    totalPriceDollar() {
      return this.dataItem?.price?.prices?.filter(
        (e) => e.info === this.currencySymbol.dolar
      )[0];
    },
    totalPriceEuro() {
      return this.dataItem?.price?.prices?.filter(
        (e) => e.info === this.currencySymbol.euro
      )[0];
    },
    totalPriceCalc() {
      let totalDollar = this.totalPriceDollar
        ? " + " +
          this.formatPriceDollar(this.totalPriceDollar?.totalPrice) +
          " USD"
        : "";
      let totalEuro = this.totalPriceEuro
        ? " + " + this.formatPriceEuro(this.totalPriceEuro?.totalPrice) + " EUR"
        : "";
      return (
        this.formatPrice(this.totalPriceTl) + " TL" + totalDollar + totalEuro
      );
    },
    screenPrice() {
      if (this.dataItem?.price?.prices == null) {
        return this.dataItem?.nextMonthPrice?.screenPrice;
      } else {
        return this.dataItem?.price?.screenPrice;
      }
    },
    getUserType() {
      const REPRESENTATIVE_CODE = 3;
      const userType = this.getUserInfo.memberType;
      return userType && userType === REPRESENTATIVE_CODE;
    },
    mergedPackagesNames() {
      const list = [];

      const platform = this.dataItem.foreignIndice?.map((i) => i?.name);
      const algorithm = this.dataItem.algorithm?.map((i) => i?.name);
      const researchList = this.dataItem.research?.map((i) => i?.name);

      const marketFeature =
        this.dataItem.package?.map((i) => i?.marketFeature?.name) || [];

      const filteredMarketFeature = marketFeature.filter(
        (name) => name !== undefined
      );
      const filteredAlgorithm = algorithm.filter((name) => name !== undefined);
      const filteredPlatform = platform.filter((name) => name !== undefined);
      const filteredResearchList = researchList.filter(
        (name) => name !== undefined
      );

      if (filteredMarketFeature.length > 0) {
        const removeDuplicated = filteredMarketFeature.filter(function (item) {
          if (!this.has(item)) {
            this.set(item, true);
            return true;
          }
        }, new Map());
        list.push(...removeDuplicated);
      }

      if (filteredPlatform.length > 0) {
        const removeDuplicated = filteredPlatform.filter(function (item) {
          if (!this.has(item)) {
            this.set(item, true);
            return true;
          }
        }, new Map());
        list.push(...removeDuplicated);
      }

      if (filteredResearchList.length > 0) {
        const removeDuplicated = filteredResearchList.filter(function (item) {
          if (!this.has(item)) {
            this.set(item, true);
            return true;
          }
        }, new Map());
        list.push(...removeDuplicated);
      }

      if (filteredAlgorithm.length > 0) {
        const removeDuplicated = filteredAlgorithm.filter(function (item) {
          if (!this.has(item)) {
            this.set(item, true);
            return true;
          }
        }, new Map());
        list.push(...removeDuplicated);
      }
      return list;
    },
    mergedForTableData() {
      const list = [];

      const processPackageItem = (item) => {
        const createLicenceFeature = (name, price, priceInfo) => {
          let currencySymbol = "";
          if (priceInfo === "₺") {
            currencySymbol = "TL";
          } else if (priceInfo === "€") {
            currencySymbol = "EUR";
          } else if (priceInfo === "$") {
            currencySymbol = "USD";
          }
          if (
            name !== null &&
            name !== undefined &&
            price !== null &&
            price !== undefined &&
            currencySymbol !== null &&
            currencySymbol !== undefined
          ) {
            list.push({
              name,
              startDate: item.startDate,
              endDate: item.endDate,
              price: `${price} ${currencySymbol}`,
            });
          }
        };

        const processFeature = (feature) => {
          const featureName = item[feature]?.name;
          const featurePrice = item[feature]?.price;
          const featureInfo = item[feature]?.priceInfo;

          if (
            featureName !== null &&
            featureName !== undefined &&
            featurePrice !== null &&
            featurePrice !== undefined &&
            featureName !== "Yok"
          ) {
            createLicenceFeature(
              item.marketFeature?.name + " " + featureName,
              featurePrice,
              featureInfo
            );
          }
        };

        processFeature("perspectiveFeature");
        processFeature("vendorFeature");
      };

      if (this.dataItem.package.length > 0) {
        this.dataItem.package.forEach(processPackageItem);
      }
      const addToListIfNotEmpty = (dataList) => {
        if (dataList.length > 0) {
          list.push(...dataList);
        }
      };

      addToListIfNotEmpty(this.dataItem.foreignIndice?.map((i) => i));
      addToListIfNotEmpty(this.dataItem.research?.map((i) => i));
      addToListIfNotEmpty(this.dataItem.algorithm?.map((i) => i));

      return list;
    },
    isCompleted() {
      return (
        parseInt(this.fundAndCommissionRates.fundAmount) >=
          this.fundAndCommissionRates.price.totalFundAmount ||
        parseInt(this.fundAndCommissionRates.commissionAmount) >=
          this.fundAndCommissionRates.price.totalCommissionAmount
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-item-container {
  padding: 20px;
  background: var(--grayscale-0);
  padding-bottom: 0px;
  @media (max-width: 768px) {
    padding: 12px;
  }

  .invoice-item {
    width: 100%;
    min-width: 850px;
    border: 1px solid var(--grayscale-30);
    background-color: var(--grayscale-0);
    margin-bottom: 0px;
    box-sizing: border-box;
    padding-bottom: 0px;
    @media (max-width: 768px) {
      min-width: auto;
    }
    &.active {
      .invoice-item__middle {
        display: flex;
      }
      .invoice-item__top__hide__arrow {
        transform: rotate(180deg);
      }
    }

    .bold {
      font-weight: bold;
    }
    .bold-title {
      @media (max-width: 676px) {
        font-size: 12px !important;
      }
    }
    &-group {
      display: flex;
      align-items: center;
    }
    .spacer {
      margin: 0 10px;
    }

    &__top {
      border-bottom: 1px solid var(--grayscale-30);
      padding-bottom: 20px;
      display: flex;
      justify-content: space-between;

      .bold {
        margin-bottom: 5px;
      }

      &__title {
        font-size: 16px;
      }

      &__subtitle {
        font-size: 16px;
      }

      &__left-area {
        width: 165px;
      }

      &__right-area {
        display: flex;
        flex: 0.8;
        justify-content: space-between;
        text-align: center;
        font-size: 13px;
        @media (max-width: 1025px) {
          flex: 0.9;
        }
      }

      &__hide {
        display: flex;
        align-items: center;
        font-size: 13px;
        color: var(--grayscale-50);
        cursor: pointer;

        &__text {
          margin-right: 3px;
        }

        &__arrow {
          transition: 0.5s;
        }
      }
    }

    &__middle {
      display: none;
      .w-100 {
        width: 100%;
      }
      flex-direction: column;
      &__row {
        position: relative;
        padding: 15px 0;
        border-bottom: 1px solid var(--grayscale-30);
        display: flex;
        justify-content: space-between;

        &__left_area {
          width: 165px;
          span {
            display: block;
          }
        }
        &__right_area {
          display: flex;
          flex: 0.8;
          text-align: center;
          font-size: 13px;
          &__detail {
            display: flex;
            align-items: center;
            flex-direction: column;
          }
          &__total {
            margin-left: auto;
            margin-right: 0px;
          }
          @media (max-width: 1025px) {
            flex: 0.9;
          }
        }
      }
    }

    &__bottom {
      display: flex;
      align-items: center;
      &.buttons {
        justify-content: flex-end;
        .set-buttons {
          max-width: 120px;
          height: 25px;
          font-size: 8pt;
        }
      }
    }
  }
  .cancel-modal {
    z-index: 9999;
    .infoArea {
      position: relative;
      bottom: initial;
    }
    .modal-heading {
      height: 40px;
      border-bottom: 1px solid var(--grayscale-30);
      display: flex;
      align-items: center;
      padding: 15px 30px;
      justify-content: space-between;
      .close {
        margin: 5px;
        cursor: pointer;
      }
    }
    .modal-bottom {
      margin-top: 1em;
      border-top: 1px solid var(--grayscale-30);
      display: flex;
      justify-content: space-between;
      padding: 15px 30px;
      .base-button {
        &.back {
          background-color: var(--color-warning);
        }
        color: var(--grayscale-0);
        width: 180px;
        font-size: 15px;
      }
    }
    .modal-body {
      padding: 15px 30px;
      &__top {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
      &__image {
        .image {
          margin-right: 30px;
          width: 96px;
          height: 140px;
          -o-object-fit: contain;
          object-fit: contain;
        }
      }
      &__info {
        &-platform {
          margin: 5px 0;
          font-size: 16px;
        }
        &_price {
          font-size: 20px;
          font-weight: bold;
          margin-top: 5px;
        }
      }
    }
  }
}

.invoice-item {
  border: 1px solid var(--color-primary-tint-second);
  width: 100%;
  background: var(--grayscale-0);
  margin-bottom: 20px;
  border-radius: var(--radius-first);

  &__top {
    justify-content: space-between;
    display: flex;
    padding: 16px 20px;
    border-bottom: solid 1px var(--grayscale-30);
    flex-wrap: wrap;
    gap: 50px;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 20px;
      padding: 12px;
      padding-bottom: 0px !important;
    }

    span {
      font-size: 14px;
      color: var(--grayscale-70);
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
    .left {
      flex: 1;
      display: flex;
      &.flex-04 {
        flex: 0.4;
      }
      &.flex-09 {
        flex: 0.9;
      }

      @media (max-width: 768px) {
        justify-content: flex-start;
        margin-bottom: 10px;
      }

      .section {
        margin-right: 10px;
        align-items: center;
        justify-content: center;
        display: flex;
        @media (max-width: 941px) {
          flex-wrap: wrap;
          justify-content: start;
        }
        &.section-main {
          @media (max-width: 1200px) {
            flex-direction: column;
            align-items: flex-start;
          }
          @media (max-width: 640px) {
            align-self: center;
          }
        }
        img {
          width: 80px;
          @media (max-width: 768px) {
            width: 48px;
          }
        }
        .tag {
          background: var(--grayscale-20);
          padding: 4px 5px;
          margin-right: 10px;
          border-radius: var(--radius-third);
          display: flex;
          align-items: center;
          text-align: center;
          @media (max-width: 941px) {
            margin-bottom: 5px;
            padding: 2px 8px;
          }
          .text {
            font-size: 12px;
            text-overflow: ellipsis;
            display: flex;
            align-items: center;
            .marketName {
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 47px;
              display: block;
            }
            @media (max-width: 400px) {
              font-size: 10px !important;
            }
            .icon {
              width: 42px;
              margin-right: -17px;
            }
          }
        }
      }
      .section-2 {
        flex-direction: row;
        align-items: unset;
        @media (max-width: 1200px) {
          margin-top: 11px;
        }
      }
      .section-1 {
        flex-direction: column;
        align-items: start;
        @media (max-width: 768px) {
          line-height: 24px;
        }
        h5 {
          font-weight: 500;
          line-height: 25px;
          @media (max-width: 768px) {
            font-size: 14px;
            line-height: normal;
          }
        }
      }
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 1;
      gap: 55px;

      &.for-button {
        align-items: flex-start;
        flex: 0;
        margin-left: 30px;
        min-width: 36px;
        @media (max-width: 768px) {
          margin-left: 0px;
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }

      @media (max-width: 1200px) {
        gap: 10px;
      }
      @media (max-width: 768px) {
        flex-wrap: wrap;
        justify-content: space-evenly;
        gap: 10px 0px;
      }
      .col {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        text-align: center;

        h6 {
          line-height: normal;
          color: var(--color-primary-black-metallic);
          font-size: 12px !important;
          font-weight: 600;
          @media (max-width: 600px) {
            line-height: normal;
          }
        }
        span {
          color: var(--grayscale-120);
          display: flex;
          justify-content: center;
          font-size: 12px;
          font-weight: 400;
          .tooltip svg {
            transform: scale(0.7);
            margin-top: -5px;
          }
        }
      }
      .button-area {
        padding: 0px;
        width: auto;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        font-weight: 500;
        position: relative;
        display: flex;
        flex: 1;
        align-items: center;

        &.d-none {
          display: none;
        }
        .text {
          margin-left: 5px;
          color: var(--color-primary-default);
        }
        .dropdown {
          visibility: hidden;
          opacity: 0;
          position: absolute;
          width: 165px;
          right: 0;
          top: 20px;
          background-color: #fff;
          border-radius: var(--radius-first);
          box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.4);
          z-index: 1;
          padding: 7px 0;
          &-item {
            padding: 7px 15px;
            text-align: left;
            &:hover {
              background: #e9e9eb;
            }
            &__text {
              font-size: 14px;
            }
          }
        }
        &:hover {
          .dropdown {
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }
  }
  &__middle {
    padding: 12.5px 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      padding: 10px 0px;
      flex-direction: column;
    }

    @media (max-width: 320px) {
      justify-content: center;
    }

    .left,
    .right {
      display: flex;
      align-items: center;
      .item {
        &.integration-warning {
          svg {
            filter: invert(31%) sepia(71%) saturate(7020%) hue-rotate(351deg)
              brightness(89%) contrast(131%);
            transition: all 1s ease-in;
            @mixin rotationBell($animationName, $animationTime) {
              -webkit-animation: #{$animationName} #{$animationTime} infinite;
              -moz-animation: #{$animationName} #{$animationTime} infinite;
              animation: #{$animationName} #{$animationTime} infinite;
            }

            @mixin keyframes($animationName) {
              @-webkit-keyframes #{$animationName} {
                @content;
              }

              @-moz-keyframes #{$animationName} {
                @content;
              }

              @keyframes #{$animationName} {
                @content;
              }
            }
            @include rotationBell(rotateAnimation, 0.5s);

            @include keyframes(rotateAnimation) {
              0% {
                transform: rotate(0deg);
              }
              25% {
                transform: rotate(15deg);
              }
              50% {
                transform: rotate(0deg);
              }
              75% {
                transform: rotate(-15deg);
              }
              100% {
                transform: rotate(0deg);
              }
            }
          }
        }
        span {
          color: var(--grayscale-70);
        }
        strong {
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
    .left {
      display: flex;
      justify-content: space-between;
      align-items: center;

      @media (max-width: 650px) {
        padding-top: 10px;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 10px;
      }

      @media (max-width: 768px) {
        padding: 0px;
        justify-content: center;
        &.package-container {
          width: 100%;
          .item {
            width: 100%;
            text-align: center;
            flex-flow: unset;
            flex-wrap: wrap;
          }
        }
      }
      .item {
        display: flex;
        gap: 3px;
        font-size: 12px;

        &:nth-child(2) {
          @media (max-width: 375px) {
            display: block;
            width: 100%;
            text-align: center;
          }
          span {
            margin: 0px 5px;
          }
        }
      }
    }
    .right {
      @media (max-width: 768px) {
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 10px;
      }
    }
  }
  &__bottom {
    display: flex;
    align-items: center;
    background: var(--grayscale-140);
    font-size: 12px;
    justify-content: space-between;
    flex-wrap: wrap;
    position: relative;
    .toggle {
      transform: rotate(180deg);
      transition: 0.2s ease-in-out;
      &.active {
        transform: rotate(0deg);
        transition: 0.2s ease-in;
      }
    }
    .left {
      padding: 18px 20px;
      flex: 0.99;

      @media (max-width: 768px) {
        padding: 12px;
      }

      .item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        @media (max-width: 768px) {
          justify-content: center;
        }
        strong {
          margin-right: 10px;
          font-weight: bold;
          @media (max-width: 768px) {
            width: 100%;
          }
        }
        .items {
          display: flex;
          align-items: center;
          &.hide {
            display: none;
          }
          @media (max-width: 768px) {
            justify-content: center;
            flex: 0 1 auto;
          }
        }
        .seperator {
          width: 1px;
          height: 22px;
          display: inline-block;
          margin: 0px 10px;
          background: var(--grayscale-130);
          @media (max-width: 768px) {
            margin: 6px 9px;
          }
        }
      }
    }
    .right {
      align-items: center;
      cursor: pointer;
      padding: 0px 20px;

      @media (max-width: 768px) {
        padding: 0px;
        position: absolute;
        right: 10px;
        top: 10px;
      }
    }
    &__packages {
      width: 100%;

      .accordion-wrapper {
        position: relative;
        display: table;
        width: 100%;
        border: 1px solid var(--color-primary-tint-second);
        @media (max-width: 768px) {
          display: block;
        }
        &__row,
        &__row__cell {
          padding: 13px 20px;
        }

        &__row {
          display: table-row;
          @media (max-width: 768px) {
            display: flex;
            padding: 0px;
            flex-wrap: wrap;
            border-bottom: 1px solid var(--color-primary-tint-second);
          }
          &:nth-child(2n) {
            background: var(--color-primary-zebra);
          }

          &.caption {
            display: none;
            background-color: var(--color-primary-tint);
            font-size: 12px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            position: sticky;
            top: 0px;

            &.active {
              display: table-row;
              @media (max-width: 768px) {
                display: flex;
                padding: 16px 12px;
              }
            }

            @media screen and (max-width: 768px) {
              position: sticky;
              top: 0px;
            }
            .caption {
              &:first-child {
                text-align: left;
                @media (max-width: 768px) {
                  justify-content: flex-start;
                  padding: 0px;
                }
              }
              @media (max-width: 768px) {
                &:nth-child(3) {
                  justify-content: flex-end;
                  position: relative;
                  right: 12px;
                }
              }
              &:last-child {
                @media (max-width: 768px) {
                  display: none;
                }
              }
              text-align: center;
            }
          }
          &__cell {
            display: table-cell;
            box-sizing: border-box;
            color: var(--color-primary-black-metallic);
            border-top: 1px solid #ecedef;

            @media (max-width: 768px) {
              display: flex;
              width: calc(100% / 3);
              justify-content: center;
              padding: 0px;
              font-size: 12px;
              align-items: center;
              border: none;
              line-height: normal;
              &:first-child {
                justify-content: flex-start;
                padding-left: 12px;
              }
              &:last-child {
                flex-basis: 100%;
                justify-content: flex-end;
                border-top: 1px solid var(--color-primary-tint-second);
                border-bottom: 1px solid var(--color-primary-tint-second);
                padding-right: 12px;
                min-height: 32px !important;
              }
              &:not(.caption):nth-child(3) {
                position: relative;
                right: 12px;
                justify-content: flex-end;
              }
              &:not(.caption) {
                min-height: 58px;
              }
            }
            .my__price {
              margin-left: 15px;
              &-text {
                &.desktop {
                  @media (min-width: 768px) {
                    display: block;
                  }
                }
                display: none;
                @media (max-width: 768px) {
                  display: inline-block;
                  font-weight: 600;
                  color: var(--color-primary-black-metallic);
                }
              }
            }
            .seperator {
              display: inline-block;
              margin-left: 4px;
            }
            @media (min-width: 768px) {
              &:not(.caption) {
                min-height: 58px;
              }
              &:not(.caption):first-child {
                min-width: 300px;
              }
              &:nth-child(2) {
                width: 135px;
                padding: 13px 0px;
              }
              &:nth-child(3) {
                width: 140px;
                padding: 13px 0px;
              }
              &:nth-child(4) {
                width: 110px;
                padding-left: 0px;
              }
            }

            &:not(.caption):nth-child(2),
            &:not(.caption):nth-child(3),
            &:not(.caption):nth-child(4) {
              color: var(--grayscale-120);
              text-align: center;
            }
          }
          &.screenPrice {
            @media (max-width: 768px) {
              .accordion-wrapper__row__cell {
                &:first-child {
                  width: max-content;
                  font-weight: 600;
                }
                &:nth-child(2),
                &:nth-child(3) {
                  display: none;
                }
                &:last-child {
                  flex-basis: auto;
                  border: none;
                  padding-left: 5px;
                  max-width: max-content;
                }
              }
            }
          }
        }

        &.active {
          .accordion-content {
            display: table-row-group;
            background: var(--grayscale-0);
            @media (max-width: 768px) {
              display: flex;
              flex-wrap: wrap;
              flex-direction: column;
            }
          }
          .collapse-icon {
            transform: rotate(0deg);
          }
        }
        .accordion-title-wrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .collapse-icon {
          transform: rotate(180deg);
        }
        .accordion-content {
          display: none;
        }
      }
    }
  }
  &__price {
    font-size: 12px;
    margin-right: 20px;
    padding-right: 20px;
    color: var(--color-primary-black-metallic);
    font-weight: 600;
    position: relative;
    &__text {
      font-weight: 400;
    }
    &::after {
      content: "";
      display: block;
      width: 1px;
      height: 22px;
      background: var(--color-primary-tint-second);
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
    }
    @media (max-width: 768px) {
      margin-right: 0px;
      padding-right: 0px;
    }
  }
  &__status {
    color: var(--color-primary-black-metallic);
    font-size: 12px;

    &__stat {
      &.request {
        font-weight: 600;
        margin-left: 8px;
      }
      &.active {
        color: var(--color-primary-active) !important;
        margin-left: 8px;
      }
      &.passive {
        color: var(--color-warning) !important;
        margin-left: 8px;
      }
    }
  }

  .cancel-modal {
    z-index: 9999;
    .infoArea {
      position: relative;
      bottom: initial;
    }
    .modal-heading {
      height: 40px;
      border-bottom: 1px solid var(--grayscale-30);
      display: flex;
      align-items: center;
      padding: 15px 30px;
      justify-content: space-between;
      .close {
        margin: 5px;
        cursor: pointer;
      }
    }
    .modal-bottom {
      margin-top: 1em;
      border-top: 1px solid var(--grayscale-30);
      display: flex;
      justify-content: flex-end;
      padding: 15px 30px;
      .base-button {
        background-color: var(--color-warning);
        color: var(--grayscale-0);
        width: 180px;
        font-size: 15px;
      }
    }
    .modal-body {
      padding: 15px 30px;
      &__top {
        display: flex;
        align-items: center;
      }
      &__image {
        .image {
          margin-right: 30px;
          width: 96px;
          height: 140px;
          -o-object-fit: contain;
          object-fit: contain;
        }
      }
      &__info {
        &-platform {
          margin: 5px 0;
          font-size: 16px;
        }
        &_price {
          font-size: 20px;
          font-weight: bold;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>
